var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',{staticClass:"not-found-page"},[_c('div',{staticClass:"centered"},[_c('h1',[_c('i',{staticClass:"not-found-icon nc-icon nc-puzzle-10"}),_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('requestedPageNotFound')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }